export default "__VITE_ASSET__DZYA0h0H__"